import { StyleSheet, View } from 'react-native'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../../models'
import { fontFamily } from '../../../theme'
import { palette } from '../../../theme/palette'
import { WalkthroughType } from '../../../models/game/walkthrough'
import { ReactNode } from 'react'
import { NextButton } from './Buttons/NextButton'
import { PlayAgainButton } from './Buttons/PlayAgainButton'
import { ContinueWalkthroughButton } from './Buttons/ContinueWalkthroughButton'
import { PlayPracticeGameButton } from './Buttons/PlayPracticeGameButton'
import { LearnTheBasicsButton } from './Buttons/LearnTheBasicsButton'
import { DS } from '../../../design-system'
import { useIsEmbeddedSegment } from '@/hooks/useIsEmbeddedSegment'

type Button = 'continuewalkthrough' | 'playagain' | 'praticegame'
const ButtonsByWalkthrough: Record<WalkthroughType, Button[]> = {
  TableTour: ['playagain', 'praticegame', 'continuewalkthrough'],
  RaiseOrFold: ['playagain', 'continuewalkthrough'],
  DealTheFlop: ['playagain', 'praticegame']
}

const Buttons: Record<Button, ReactNode> = {
  continuewalkthrough: <ContinueWalkthroughButton />,
  playagain: <PlayAgainButton />,
  praticegame: <PlayPracticeGameButton />
}

export const WalkthroughOverlayActions = observer(() => {
  const isEmbedded = useIsEmbeddedSegment()
  const excludeButtonsEmbedded = ['praticegame', 'continuewalkthrough']
  const {
    game: { isLastStep, walkthroughType }
  } = useStore()

  if (!walkthroughType) return null

  const buttons = ButtonsByWalkthrough[walkthroughType]
    .filter((name) => {
      if (!isEmbedded) {
        //hide play again for table tour on non embedded experience
        if (name === 'playagain' && walkthroughType === 'TableTour') {
          return false
        }
        return true
      }
      return !excludeButtonsEmbedded.includes(name)
    })
    .map((b) => Buttons[b])

  return <View style={styles.container}>{!isLastStep ? <NextButton /> : buttons}</View>
})

const styles = StyleSheet.create({
  container: {
    marginBottom: 40,
    paddingHorizontal: DS.spacing[24],
    gap: 8
  },
  button: {
    backgroundColor: palette.white,
    paddingHorizontal: 80,
    height: 45,
    borderRadius: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  },
  text: {
    fontFamily: fontFamily.GTAmericaStandardMedium,
    fontWeight: '600',
    textAlign: 'center'
  },
  outlined: {
    backgroundColor: 'transparent',
    borderColor: palette.white,
    borderWidth: 1
  },
  outlinedText: {
    color: palette.white
  }
})
